<template>
	<div class="body">
		<div class="body-left">
			<div class="left-head">
				发布人信息
			</div>
			<div class="left-body" v-if="!proDetail.user_record.phone">
				<div class="body-item" v-if="loading">
					<div class="item-title">
						{{ proDetail.user_info.nickname }}
					</div>
					<div class="item-content">
						联系方式:{{proDetail.user_info.mobile || proDetail.user_info.email }}
					</div>
				</div>
				<div class="body-item">
					<div class="item-title">
						<!-- {{proDetail.user_record.company}} -->
					</div>
					<!-- <div class="item-content">
						清华大学 <span style="color: #0052D9;margin-left: 5px;cursor:pointer;"
							@click="$router.push(`/geniusClub/companyInfo?id=${1}`)">(已认证)</span>
					</div> -->
					<!-- <div class="item-content">
						北京科技 <span style="margin-left: 5px;">(未认证)</span>
					</div> -->
				</div>
				<div class="body-item">
					<div class="item-title">
						公司评价
					</div>
					<div class="item-content">
						暂无
					</div>
				</div>
				<!-- 	<div class="guanzhu">
					关注公司
				</div> -->
			</div>
			<div class="left-body" v-else>
				<div class="body-item">
					<div class="item-title">
						{{ proDetail.user_record.name }}
					</div>
					<div class="item-content">
						联系方式:{{ proDetail.user_record.phone }}
					</div>
				</div>
				<div class="body-item">
					<div class="item-title">
						{{ proDetail.user_record.company }}
					</div>
					<!-- <div class="item-content">
						清华大学 <span style="color: #0052D9;margin-left: 5px;cursor:pointer;"
							@click="$router.push(`/geniusClub/companyInfo?id=${1}`)">(已认证)</span>
					</div> -->
					<!-- <div class="item-content">
						北京科技 <span style="margin-left: 5px;">(未认证)</span>
					</div> -->
				</div>
				<div class="body-item">
					<div class="item-title">
						公司评价
					</div>
					<div class="item-content">
						暂无
					</div>
				</div>
				<!-- 	<div class="guanzhu">
					关注公司
				</div> -->
			</div>
		</div>
		<div class="body-main" v-if="loading">
			<div class="main-head">
				<div class="head-left">
					<img :src='getImgSrc(proDetail.image)' style="width: 238px;height: 238px;" alt="">
				</div>
				<div class="head-right">
					<div class="title">
						{{ proDetail.title }}
					</div>
					<div class="introduce">
						<div>科学类别：{{ proDetail.subjectcate_name }}</div>
						<div>行业类别：{{ proDetail.industry_name }}</div>
						<div>更新时间：{{ timeConversion(proDetail.updatetime) }}</div>
					</div>
					<div class="content">
						<p v-html="proDetail.summary_info"></p>
					</div>
					<div class="bottom">
						<span style="color: #0052D9;"><i class="el-icon-view"
								style="font-size: 20px;"></i>{{ proDetail.hits }}</span>
						<span style="margin-left: 20px;cursor: pointer;" @click="handleLike"
							:style="proDetail.collect == 1 ? 'color: #0052D9;' : ''"><i class="el-icon-star-on"
								style="font-size:20px;"></i>{{ proDetail.collect_num }}</span>
					</div>
				</div>
			</div>
			<div class="main-body">
				<div class="body-item">
					<div style="background:#E5EDFB;">
						<div
							style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
							基本信息
						</div>
					</div>
					<div v-if="bindInfo.bid_info"
						style="height: 100px;text-align: center;font-size: 20px;line-height: 100px;">
						<div>
							已选中 <span style="text-decoration: underline;cursor: pointer;"
								@click="$router.push(`/solutionDetail/?id=${bindInfo.scheme_info.id}`)">
								"{{bindInfo.scheme_info.title}}" </span>
						</div>

					</div>
					<div v-else>
						<div class="body-item-title">
							<span>1、选中成交乙方</span>
							<div @click="choosePartyB">确认成交</div>
						</div>
						<div class="item-detail">
							<div class="table" v-if="partyBList.lists.length">
								<el-radio-group v-model="result" style="width: 100%;"
									:disabled="partyBList.check_status ? true : false">
									<div class="table-line" v-for="(item, index) in partyBList.lists"
										:style="index % 2 == 0 ? 'background: #FAFAFA;' : ''" :key="item.id">
										<div class="line-check">
											<el-radio type="checkbox" :label="item.id">{{ '' }}</el-radio>
										</div>
										<div class="line-id">
											{{ index + 1 }}
										</div>
										<div class="fangan" style="cursor: pointer;"
											@click="$router.push(`/solutionDetail/?id=${item.scheme_id}`)">
											<!-- <div style="color: red;font-size: 12px;" v-if="item.type == 'person'">这是个人公司，签合同时注意法律责任</div> -->
											{{ item.scheme_title }}
										</div>
										<div class="nickName">
											{{ item.user_info.nickname }}
										</div>
										<div class="company">
											{{ item.company_info ? item.company_info.company_name : '个人用户' }}
										</div>
										<div class="deal">
											<!-- {{item.deal}} -->
										</div>
										<div class="score">
											<!-- <span style="color: red;"></span>评分 -->
										</div>
									</div>
								</el-radio-group>
							</div>
							<div v-else class="table" style="padding: 15px;color: #989898;">
								暂未有人提交方案
							</div>


						</div>
					</div>
					<!-- 	<div class="body-mid-footer">
					    加载更多<img src='../../assets/images/darrwo.png' alt="">
					</div> -->
				</div>
				<div  v-if="bindInfo.bid_info"  class="body-item">
					<div class="body-item-title">
						<span>进度更新</span>

					</div>
				</div>
				<el-dialog title="添加项目进度" center :visible.sync="dialogVisible8" width="500px">
					<el-input style="font-size: 16px;" placeholder="请输入项目进度" v-model="progressTitle"> </el-input>
					<div style="margin-top: 20px;display: flex;justify-content: center;">
						<el-date-picker size="large" format="yyyy 年 MM 月 dd 日" v-model="progressTime"
							value-format="yyyy-MM-dd" placeholder="选择日期">
						</el-date-picker>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible8 = false">取 消</el-button>
						<el-button type="primary" @click="getAddProgress">确 定</el-button>
					</span>
				</el-dialog>
				<div  v-if="bindInfo.bid_info"  class="item-detail">
					<div class="table">
						<!--  :style="index%2==0?'background: #FAFAFA;':''" -->


						<!-- :style="index%2==0?'background: #FAFAFA;':''" -->
						<div class="table-line" v-for="(item, index) in updateList"
							:style="index % 2 == 0 ? 'background: #FAFAFA;' : ''" :key="item.id">
							<div class="line-icon">
								<img src="../../assets/images/yanshou.png" style="width: 19px;" alt="">
							</div>

							<div class="line-status">
								{{ item.name }}
							</div>
							<div class="starScore">
								<el-rate allow-half v-model="item.score" @change="projectEditProgress(item)"></el-rate>
							</div>

							<div class="jindu" style="padding-left: 15px;width: 200px;">
								<el-date-picker format="yyyy 年 MM 月 dd 日" @change='changeDate($event,item)'
									v-model="item.plan_date" value-format="yyyy-MM-dd" placeholder="选择日期">
								</el-date-picker>
								<!-- {{ timeConversion(item.updatetime) }} -->
							</div>
							<div class="zhuanjia">
								<div @click="$router.push('/projectNeed/KTDW')">找专家</div>
								<div @click="$router.push('/projectNeed/KTDW')">专家会审</div>
							</div>
						</div>
						<div class="table-line"
							style="background: #FAFAFA;justify-content: space-between;padding-right: 15px;box-sizing: border-box;">
							<div class="line-icon">
								<img src="../../assets/images/circleP.png"
									style="width: 23px;height: 23px;cursor: pointer;" @click="dialogVisible8 = true">

							</div>
							<div style="display: flex;align-items: center;">
								项目金额:{{bindInfo.bid_info ? bindInfo.bid_info.price : proDetail.price}}
								<div class="zhuanjia" style="margin-left: 10px;">
									<div @click="priceDialogVisible = true">修改价格</div>
								</div>
							</div>
						</div>

					</div>
				</div>
				<div class="body-item">
					<div  v-if="bindInfo.bid_info"  class="body-item-title">
						<span>双方互评</span>

					</div>
				</div>
				<div style="padding: 10px 15px" v-if="bindInfo.bid_info">
					<div class="table">
						<div class="table-line" v-if="bindInfo.bid_info.bid_acquire_remark" style="display: flex;">

							<div class="jindu" style="flex: 1;">
								甲方评价：{{bindInfo.bid_info.bid_acquire_remark}}
							</div>
							<div class="starScore">
								<el-rate allow-half v-model="bindInfo.bid_info.bid_acquire_score * 1"
									disabled></el-rate>
							</div>
						</div>
						<div class="table-line" v-if="bindInfo.bid_info.owner_acquire_remark" style="display: flex;">

							<div class="jindu" style="flex: 1;">
								乙方评价：{{bindInfo.bid_info.owner_acquire_remark}}
							</div>
							<div class="starScore">
								<el-rate allow-half v-model="bindInfo.bid_info.owner_acquire_score * 1"
									disabled></el-rate>
							</div>
						</div>
					</div>
				</div>
				<div class="item-detail"  v-if="bindInfo.bid_info">
					<p style="display: flex;">评分： <el-rate allow-half v-model="starScore"></el-rate></p>
					<el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="PJarea">
					</el-input>
					<div style="display: flex;justify-content: flex-end;">
						<div class="pinglBtn" @click="projectAcommentB">发表评论</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="修改价格" :visible.sync="priceDialogVisible" width="30%">
			<el-input placeholder="请输入价格" v-model="setPrice"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="priceDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="jfSetprice">确 定</el-button>
			</span>
		</el-dialog>
	</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				progressTime: '',
				shoucang: false,
				checkList: [],
				result: '',
				starScore: '',
				PJarea: '',
				proDetail: '',
				canLike: true,
				partyBList: [],
				loading: false,
				progressTitle: '',
				dialogVisible8: false,
				updateList: [],
				bindInfo: '',
				setPrice: '',
				priceDialogVisible: false
			}
		},
		created() {
			this.getPartyBList()
			this.getDetail(this.$route.query.id)
		},
		methods: {
			async jfSetprice() {
				if (this.setPrice) {
					const change = await this.$api.jfSetprice({
						projectneed_id: this.proDetail.id,
						id: this.bindInfo.bid_info.id,
						price: this.setPrice
					})
					if (change.code == 1) {
						this.$message({
							message: change.msg,
							type: 'success'
						})
						this.priceDialogVisible = false
					} else {
						this.$message({
							message: change.msg,
							type: 'error'
						})
					}
				}
			},
			async projeckGetbindInfo() {
				const info = await this.$api.projeckGetbindInfo({
					projectneed_id: this.proDetail.id
				})
				this.bindInfo = info.data
				this.loading = true
			},
			async changeDate(e, item) {
				console.log(e, item);
				const change = await this.$api.projectEditProgress({
					plan_date: e,
					id: item.id,
					projectneed_id: this.proDetail.id
				})
				if (change.code == 1) {
					this.$message({
						message: change.msg,
						type: 'success'
					})
				} else {
					this.$message({
						message: change.msg,
						type: 'error'
					})
				}
			},
			async projectAcommentB() {
				const comment = await this.$api.projectAcommentB({
					bid_acquire_remark: this.PJarea,
					bid_acquire_score: this.starScore,
					id: this.partyBList.bid_id
				})
				if (comment.code == 1) {
					this.$message({
						message: comment.msg,
						type: 'success'
					})
					this.projeckGetbindInfo()
					this.starScore = ''
					this.PJarea = ''
				} else {
					this.$message({
						message: comment.msg,
						type: 'error'
					})
				}
				console.log(comment);
			},
			async projectEditProgress(item) {
				const progress = await this.$api.projectEditProgress({
					id: item.id,
					projectneed_id: this.proDetail.id,
					score: item.score
				})
				console.log(item);
			},
			async getUpdateList() {
				const list = await this.$api.getProjectUpdateList({
					projectneed_id: this.proDetail.id
				})
				list.data.forEach(item => {
					if (item.score) {
						item.score = parseFloat(item.score)
					}
				})
				this.updateList = list.data
			},
			async choosePartyB() {
				if (this.result == '') {
					this.$message({
						message: '请选择方案',
						type: 'error'
					})
					return
				} else {
					const choose = await this.$api.projectPartyAChoosePartyB({
						projectneed_id: this.proDetail.id,
						id: this.result
					})
					if (choose.code == 1) {
						this.$message({
							message: choose.msg,
							type: 'success'
						})
						this.projeckGetbindInfo()
						// this.partyBList.check_status = 1
					} else {
						this.$message({
							message: choose.msg,
							type: 'error'
						})
					}
				}
			},
			async getAddProgress() {
				if (this.progressTitle == '') {
					this.$message({
						message: '输入不能为空',
						type: 'error'
					})
					return
				} else {
					const progress = await this.$api.projectAddProgress({
						projectneed_id: this.proDetail.id,
						name: this.progressTitle,
						order: 50,
						plan_date: this.progressTime
					})
					if (progress.code == 1) {
						this.getUpdateList()
						this.dialogVisible8 = false
						this.$message({
							message: progress.msg,
							type: 'success'
						})
						this.progressTitle = ''
						this.progressTime = ''
						// this.partyBList.check_status = 1
					} else {
						this.$message({
							message: progress.msg,
							type: 'error'
						})
					}
				}
			},
			async getDetail(id) {
				const detail = await this.$api.projectneedGetDetail({
					id: id
				})
				this.proDetail = detail.data
				await this.projeckGetbindInfo()
				this.getUpdateList()
			},
			async getPartyBList() {
				const list = await this.$api.getProjectPartyBList({
					projectneed_id: this.$route.query.id
				})
				console.log(list);
				this.partyBList = list.data
				this.result = list.data.bid_id
			},
			handleLike() {
				if (this.canLike) {
					this.canLike = false;
					this.collectHandler();
					setTimeout(() => {
						this.canLike = true;
					}, 1000);
				}
			},
			async collectHandler(id) {
				if (this.proDetail.collect) {
					const collect = await this.$api.productCancelCollect({
						id: this.proDetail.id
					})
					if (collect.code == 1) {
						this.$message({
							message: '取消收藏',
							type: 'warning',
							center: true
						})
						this.proDetail.collect = 0
						this.proDetail.collect_num -= 1
					}
				} else {
					const collect = await this.$api.productCollect({
						id: this.proDetail.id
					})
					if (collect.code == 1) {
						this.$message({
							message: '收藏成功',
							type: 'success',
							center: true
						})
						this.proDetail.collect = 1
						this.proDetail.collect_num += 1
					}
				}
			},
		}
	}
</script>
<style>
	.el-date-editor.el-input {
		width: 100%;
	}

	/* .el-radio__label {
	color: black;
}

.radio {
	position: relative;
	display: inline-block;
	margin-right: 12px;
}

.radio input {
	width: 18px;
	height: 18px;
	appearance: none;
	-webkit-appearance: none;
	opacity: 0;
	outline: none;
}



.el-radio__inner {
	border-radius: 0;
}

.el-radio__label {
	display: none;
}

.el-radio__inner::after {
	content: "";
	position: absolute;
	text-align: center;
	border-radius: 0;
	width: 14px;
	height: 14px;
	content: "✓";
	color: #fff;
	font-weight: bold;
	background-color: #0052D9;
} */

	input[type=checkbox] {
		cursor: pointer;
		position: relative;
		width: 25px;
		height: 24px;
		font-size: 16px;
	}

	input[type=checkbox]::after {
		position: absolute;
		top: 0;
		color: #000;
		width: 25px;
		height: 24px;
		display: inline-block;
		visibility: visible;
		padding-left: 0px;
		text-align: center;
		content: ' ';
		border-radius: 3px
	}

	input[type=checkbox]:checked::after {
		content: "✓";
		color: #fff;
		font-size: 16px;
		font-weight: bold;
		background-color: #0052D9;
	}

	.el-rate {
		height: 30px;
	}

	.el-icon-star-on:before {
		font-size: 24px;
	}

	.el-icon-star-off:before {
		font-size: 24px;
	}

	.el-rate__icon {
		font-size: 24px;
	}
</style>
<style scoped lang="less">
	.body-mid-footer {
		display: flex;
		padding: 20px;
		box-sizing: border-box;
		height: 50px;
		background: #F6F6F6;
		justify-content: center;
		font-size: 18px;
		cursor: pointer;
		align-items: center;
		width: 1065px;
		margin: 10px auto;
		margin-bottom: 40px;

		&>img {
			margin-left: 20px;
			width: 16px;
			height: 16px;
		}
	}

	.pinglBtn {
		width: 132px;
		height: 38px;
		background: #0052D9;
		border: 1px solid #E5E5E5;
		margin-top: 20px;
		color: white;
		line-height: 38px;
		text-align: center;
		cursor: pointer;
	}

	.table {
		border: 1px solid #EEEEEE;
		text-align: center;

		.table-line {
			.jindu {
				width: 130px;
			}

			.line-status {
				width: 120px;
				border: 1px solid #EEEEEE;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.starScore {
				font-size: 30px;
				width: 190px;
				border: 1px solid #EEEEEE;
				display: flex;
				height: 100%;
				align-items: center;
				justify-content: center;
			}

			.zhuanjia {
				display: flex;
				flex: 1;
				justify-content: flex-end;

				div {
					margin-right: 20px;
					width: 132px;
					color: #0052D9;
					height: 34px;
					border: 1px solid #0052D9;
					line-height: 34px;
					cursor: pointer;
				}

				&>div:last-child {
					background: #0052D9;
					color: white;
				}
			}

			.line-icon {
				width: 75px;
				display: flex;
				justify-content: center;
				border: 1px solid #EEEEEE;
				height: 100%;
				align-items: center;

				img {
					width: 23px;
					height: 23px;
				}
			}

			.line-id {
				font-size: 18px;
				width: 75px;
			}

			.fangan {
				width: 210px;
			}

			.nickName {
				width: 200px;
			}

			.company {
				width: 250px;
			}

			.deal {
				width: 180px;
			}

			.score {
				width: 120px;
			}

			align-items: center;
			display: flex;
			font-size: 16px;
			border-bottom: 1px solid #EEEEEE;
			height: 55px;

			.line-check {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 50px;
				border: 1px solid #EEEEEE;
				height: 100%;
			}
		}

		.darkbg {
			background: #FAFAFA;
		}
	}

	.body {
		display: flex;
		padding-bottom: 40px;
		justify-content: space-between;

		.body-main {
			.main-body {
				.body-item-title {
					display: flex;
					justify-content: space-between;
					font-size: 18px;
					padding: 20px;
					align-items: center;

					&>div {
						cursor: pointer;
						width: 129px;
						line-height: 40px;
						text-align: center;
						height: 40px;
						background: #F6F6F6;
						border: 1px solid #D2D2D2;
					}
				}

				.item-detail {
					.detail-line {
						display: flex;
						margin: 10px;

						p {
							width: 350px;
							overflow: hidden;
							text-overflow: ellipsis;
						}

						a {}
					}

					padding:10px 15px;
				}

				margin-top: 20px;
				background: white;
				padding: 20px 0;
			}

			.main-head {
				.bottom {
					display: flex;

					span {
						font-size: 16px;
						display: flex;
						align-items: center;
					}

					margin-top: 25px;
				}

				.content {
					height: 100px;
					font-size: 16px;
					color: #222222;
					line-height: 26px;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.introduce {
					margin: 16px 0;
					display: flex;
					font-size: 14px;
					color: #888888;

					&>div {
						width: 33%;
					}
				}

				.head-right {
					flex: 1;
					padding: 8px 15px;
					box-sizing: border-box;

					.title {
						font-size: 20px;
						font-weight: bold;
					}
				}

				display: flex;
				padding: 19px;
				box-sizing: border-box;
				height: 277px;
				background: #FFFFFF;
			}

			width:1100px;

		}
	}

	.body-left {
		.left-body {
			.guanzhu {
				width: 230px;
				height: 46px;
				background: #0052D9;
				line-height: 46px;
				color: white;
				text-align: center;
				cursor: pointer;
			}

			.body-item {
				margin: 10px 0;
				margin-bottom: 30px;

			}

			.item-title {
				font-size: 18px;
				margin-bottom: 10px;
			}

			.item-content {
				margin: 5px 0;
				color: #888888;
			}

			padding: 10px 15px;
			box-sizing: border-box;
		}

		.left-head {
			font-size: 20px;
			line-height: 69px;
			padding-left: 15px;
			box-sizing: border-box;
			font-weight: bold;
			width: 260px;
			height: 69px;
			color: #0052D9;
			background: #E5EDFB;
		}

		width: 260px;
		height: 330px;
		background: #FFFFFF;
	}
</style>